var _rect, _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 982,
    viewBox: "0 0 1512 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1556,
    height: 1023,
    transform: "translate(-29 -27)",
    fill: "url(#paint0_linear_3488_12930)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.139 469.082C314.957 455.96 85.5173 508.006 -21 537.119V996H1108.81C1110.62 991.657 1100 971.198 1054.89 906.733C998.5 826.151 965.852 779.829 906.492 723.856C848.128 668.821 734.35 603.707 680.432 573.308C626.513 542.909 493.449 490.314 383.139 469.082Z",
    fill: "url(#paint1_linear_3488_12930)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3488_12930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30 1009V267.523C-27.6711 265.187 -5.94692 261.496 60.8266 274.032C146.164 290.053 256.619 334.59 297.874 357.642C337.299 379.671 475.535 451.766 568.856 457.774C628.121 461.589 692.121 452.767 780.951 476.298C834.377 490.451 861.797 512.346 954.62 516.351C1043.45 520.184 1128.29 470.791 1169.21 444.256C1221.61 410.278 1358.85 318.59 1419.23 293.057C1475.62 269.211 1510.06 260.514 1541 250V1009H-30Z",
    fill: "url(#paint2_linear_3488_12930)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3488_12930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.852 442C197.491 442 54.4777 484.629 -24.0134 511.438L-30 509.44V1001H1535V671.794C1482.62 715.255 1299.03 799.68 1196.76 829.154C1097.6 857.728 943.822 876.112 847.537 844.14C766.949 817.381 707.351 768.208 656.465 715.256C605.579 662.303 543.717 569.886 468.385 506.942C393.054 443.998 318.855 442 259.852 442Z",
    fill: "url(#paint3_linear_3488_12930)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3488_12930",
    x: -42,
    y: 238,
    width: 1595,
    height: 783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_3488_12930"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3488_12930",
    x: -42,
    y: 430,
    width: 1589,
    height: 583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_3488_12930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3488_12930",
    x1: 0,
    y1: 0,
    x2: 1567.22,
    y2: 1005.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E025A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#210165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02010F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3488_12930",
    x1: -21,
    y1: 467,
    x2: 865.737,
    y2: 1265.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01010F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#200064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#1C016A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02010F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3488_12930",
    x1: -30,
    y1: 250,
    x2: 1237.5,
    y2: 1356.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#210165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070132"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3488_12930",
    x1: -30,
    y1: 442,
    x2: 899.238,
    y2: 1539.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09013F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#150159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C016A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDark);
export default __webpack_public_path__ + "static/media/bgDark.95b368eb04b9e9721b8052bf3ba48b9c.svg";
export { ForwardRef as ReactComponent };